import type {UseFormReturn} from 'react-hook-form';

import type {VehicleLookupMaps} from '../../../utils/buildVehicleLookupMaps';
import type {AssignmentConditionFormValues} from '../assignmentConditionFormSchema';

const SET_VALUE_OPTIONS = {shouldDirty: false, shouldValidate: false} as const;

export function useResetVehicleDependentFields(
  formApi: UseFormReturn<AssignmentConditionFormValues>,
  getVehicleLookupMaps: () => VehicleLookupMaps
) {
  const resetModelAndModelFamily = () => {
    formApi.setValue('model', null, SET_VALUE_OPTIONS);
    formApi.setValue('modelFamily', null, SET_VALUE_OPTIONS);
  };

  const onVehicleTypeChange = (_newValue: unknown) => {
    formApi.setValue('fuel', null, SET_VALUE_OPTIONS);
    formApi.setValue('make', null, SET_VALUE_OPTIONS);
    resetModelAndModelFamily();
  };

  const onMakeChange = (newMakeValue: unknown) => {
    if (newMakeValue == null || !Array.isArray(newMakeValue) || newMakeValue.length === 0) {
      resetModelAndModelFamily();
      return;
    }

    const {modelToMakeMap, modelFamilyToMakeMap} = getVehicleLookupMaps();

    if (modelToMakeMap.size > 0) {
      const selectedModels = formApi.getValues('model');
      const filteredModels =
        selectedModels?.filter((modelId) => newMakeValue.includes(modelToMakeMap.get(modelId))) ??
        [];
      formApi.setValue(
        'model',
        filteredModels.length > 0 ? filteredModels : null,
        SET_VALUE_OPTIONS
      );
    } else {
      formApi.setValue('model', null, SET_VALUE_OPTIONS);
    }

    if (modelFamilyToMakeMap.size > 0) {
      const selectedModelFamilies = formApi.getValues('modelFamily');
      const filteredFamilies =
        selectedModelFamilies?.filter((familyId) =>
          newMakeValue.includes(modelFamilyToMakeMap.get(familyId))
        ) ?? [];

      formApi.setValue(
        'modelFamily',
        filteredFamilies.length > 0 ? filteredFamilies : null,
        SET_VALUE_OPTIONS
      );
    } else {
      formApi.setValue('modelFamily', null, SET_VALUE_OPTIONS);
    }
  };

  return {onVehicleTypeChange, onMakeChange};
}
